import * as React from "react";
import { useSunglassesEcommContext } from "../../../../../../../context/modules/EcommContent/SunglassesEcommContent/context/SunglassesEcommContext.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { ProductDetailCTA } from "../../../../../../../../components/CTAs/ProductDetailCTA/modules/EcommContent/components/CTAs/ProductDetailCTA/ProductDetailCTA.js";
const SunglassesCTA = () => {
  const {
    activeVariant: { sku }
  } = useProductData();
  const { productAction, handleConfiguratorOpen } = useSunglassesEcommContext();
  const handleConversionEvent = React.useCallback(() => {
  }, []);
  const onAddToCartSuccess = React.useCallback(() => {
  }, []);
  return /* @__PURE__ */ React.createElement(
    ProductDetailCTA,
    {
      action: productAction,
      handleConfiguratorOpen,
      handleConversionEvent,
      addToCartConfig: { activeSku: sku, onSuccess: onAddToCartSuccess }
    }
  );
};
export {
  SunglassesCTA
};
//# sourceMappingURL=SunglassesCTA.js.map
